import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';

import { NgTemplateAssertTypeModule } from '@recruitee/common';
import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from '../../common/button/button.module';
import { DividerModule } from './../../common/divider/divider.module';
import { DropdownHeaderModule } from './../../common/dropdown/dropdown-header/dropdown-header.module';
import { DropdownItemModule } from './../../common/dropdown/dropdown-item/dropdown-item.module';
import { HeadingModule } from './../../common/heading/heading.module';
import { IconModule } from './../../common/icon/icon.module';
import { LabelModule } from './../../common/label/label.module';
import { TagModule } from './../../common/tag/tag.module';
import { TruncateModule } from './../../common/truncate/truncate.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { FormFieldModule } from './../../forms/form-field/form-field.module';
import { InputModule } from './../../forms/input/input.module';
import { SelectDropdownModule } from './../../forms/select/select-dropdown/select-dropdown.module';
import { SelectComponent } from './select.component';

@NgModule({
  declarations: [SelectComponent],
  exports: [SelectComponent],
  imports: [
    NgTemplateAssertTypeModule,
    VirtualScrollerModule,
    LabelModule,
    CommonModule,
    RtUICoreOverlayModule,
    SelectDropdownModule,
    DropdownHeaderModule,
    FormFieldModule,
    IconModule,
    InputModule,
    I18nModule,
    DropdownItemModule,
    DividerModule,

    TruncateModule,
    ButtonModule,
    TagModule,
    HeadingModule,
  ],
})
export class SelectModule {}

export {
  SelectComponent,
  SelectGroupedOptions,
  SelectGroupOption,
  SelectOption,
  SelectOptionValue,
  SelectOptionContext,
  GroupsTemplateContext,
  SelectListTemplateContext,
  SelectGroupedSort,
} from './select.component';
